// Services and functions are administered the same way (L2-ASF): both are named
// entities that can be created, renamed, deactivated and struck off, and both keep a
// trail of who changed them.
//
// A struck-off entity leaves the listing but is never destroyed, since users and
// documents still point at it. `active` is the switch an administrator flips; the
// entity disappearing from the listing is what deletion looks like.
export type AdminEntity = {
  id: string;
  name: string;
  active: boolean;
};

// What an update moved: the value on each side.
export type AdminFieldChange = { from: string | null; to: string | null };

// What the backend answers on GET /api/:entity/:id/history. `actor_id` is a user id;
// the screen resolves it to a name when it can.
//
// `changes` is null on the actions whose label already says everything, and on the
// entries written before it was recorded: what those did not keep cannot be
// reconstructed after the fact.
export type AdminHistoryEntry = {
  actor_id: string;
  action: 'created' | 'updated' | 'activated' | 'deactivated' | 'deleted';
  at: string;
  changes: Record<string, AdminFieldChange> | null;
};

export const ADMIN_FIELD_LABELS: Record<string, string> = {
  name: 'Nom',
};

export const ADMIN_ACTION_LABELS: Record<AdminHistoryEntry['action'], string> = {
  created: 'Création',
  updated: 'Modification',
  activated: 'Activation',
  deactivated: 'Désactivation',
  deleted: 'Suppression',
};
